import { useMemo } from 'react';
import { PARTICIPANTS_SELECTION_TYPES } from '../../constants';

export function useCartProductPrice(cart) {
  return useMemo(() => {
    if (cart) {
      let price = 0;
      switch (cart.priceType) {
        case PARTICIPANTS_SELECTION_TYPES.TOP:
          price += parseFloat(cart.participants.top1.priceTotal);
          price += parseFloat(cart.participants.top2.priceTotal);
          break;
        case PARTICIPANTS_SELECTION_TYPES.TOP3:
          price += parseFloat(cart.participants.top1.priceTotal);
          price += parseFloat(cart.participants.top2.priceTotal);
          price += parseFloat(cart.participants.top3.priceTotal);
          break;
        case PARTICIPANTS_SELECTION_TYPES.GROUP:
        case PARTICIPANTS_SELECTION_TYPES.FIXED:
        case PARTICIPANTS_SELECTION_TYPES.VARIABLE:
          price += parseFloat(cart.participants.priceTotal);
          break;
      }
      return price;
    } else {
      return 0;
    }
  }, [cart]);
}
